<template>
  <div>
    <div class="corzo-page-title-wrap corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr">
          <div class="corzo-page-caption">About Us</div>
          <h1 class="corzo-page-title">关于匯德</h1>
          <div class="corzo-page-caption-divider"></div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f5f5f5;"></div>
      <div class="gdlr-core-pbf-background-wrap" style="top: 350px;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-image: url(upload/hp2-about-bg.png); background-repeat: no-repeat; background-position: top center;" data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first" id="gdlr-core-column-2049">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: 0px -30px 0px 0px; padding: 105px 40px 140px 0px; height: 665.492px;" data-sync-height="height-00">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-image: url(upload/square00.png); background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr" style="padding-bottom: 0px;">
                    <div class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style="border-width: 0px;">
                      <img src="static/images/logo.png" alt="" width="601" height="398" title="汇德">
                    </div>
                  </div>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #090909;">
                      <p>
                        匯德集团目前在香港拥有多块牌照，包括香港信托牌照、香港证券交易牌照、香港证券咨询牌照。专业团队有超过10年跨境财富规划与传承经验。并在香港、新加坡、北京、上海、 深圳都建有便利的服务网络，服务大陆及不同国家、地区的华人客户，至今已为超过上百个超高净值华人家族以及企业提供财富规划、传承、及企业信托服务。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-76282">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: 0px 0px 0px 30px; padding: 115px 0px 0px 50px; height: 665.492px;" data-sync-height="height-00">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-repeat: no-repeat; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                                                        <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption" style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                                                            <span class="gdlr-core-title-item-left-dot" style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>Huide Group
                                                        </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #090909;">
                        关于匯德<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #090909;">
                      <p>
                        匯德集团致力于为中国的新经济企业及家族办公室，在海外资本运营、法律架构、税收筹划、返程投资、信托管理、赛道投行分析、外汇解决及资产配置上进行一站式咨询服务。
                      </p>
                      <br/>
                      <p>
                        我们拥有强大的法律及税务团队，离岸架构搭建及返程投资的专业团队超过50人，目前在上海、北京、三亚及海口均设有办公室。成立至今，为多个知名企业、投资机构的出境投资、资本运作及境外公司管理提供了专业服务，主要针对VIE/红筹架构搭建、外汇备案、ODI等跨境并购业务提供一站式方案设计及运营管理。
                      </p>
                      <br/>
                      <br/>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <Team></Team>

  </div>
</template>

<script>
import Team from '@/components/Team'
export default {
  name: 'About',
  components: {
    Team
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue